import API from "@/lib/httpModule";

/**
 * Get customer aircraft
 * @returns
 */
export async function getCustomerAircrafts(query) {
	return API.get(`/customer-aircraft`, query)
		.then(async (rs) => {
			if (rs && rs.status === 200 && rs.data) {
				const response = rs.data?.data ?? {};
				return { success: true, data: response };
			}
		})
		.catch((errRes) => {
			return {
				success: false,
				errors: errRes,
			};
		});
}

/**
 * Get customer aircraft detail by id
 * @param {String} slug
 * @returns
 */
export async function getCustomerAircraftDetail(slug) {
	return API.get(`/customer-aircraft/${slug}`)
		.then(async (res) => {
			const response = res.data;
			return { success: true, data: response };
		})
		.catch((errRes) => {
			return {
				success: false,
				errors: errRes,
			};
		});
}

/**
 * Get aircraft category
 * @returns
 */
export async function getAircraftCategories(query) {
	return API.get(`/aircraft-category`, query)
		.then(async (rs) => {
			if (rs && rs.status === 200 && rs.data) {
				const response = rs.data?.data ?? {};
				return { success: true, data: response };
			}
		})
		.catch((errRes) => {
			return {
				success: false,
				errors: errRes,
			};
		});
}

/**
 * Get aircraft category detail by id
 * @param {String} slug
 * @returns
 */
export async function getAircraftCategoryDetail(slug) {
	return API.get(`/aircraft-category/${slug}`)
		.then(async (res) => {
			const response = res.data;
			return { success: true, data: response };
		})
		.catch((errRes) => {
			return {
				success: false,
				errors: errRes,
			};
		});
}

/**
 * Get aircraft type details
 * @returns
 */
export async function getAircraftTypeDetails(uid, preview = false) {
	return API.get(`/aircraft-type/${uid}?preview=${preview}`)
		.then(async (rs) => {
			if (rs && rs.status === 200 && rs.data) {
				const response = rs.data?.data ?? {};
				return { success: true, data: response };
			}
		})
		.catch((errRes) => {
			return {
				success: false,
				errors: errRes,
			};
		});
}

/**
 * Get aircrafts
 * @returns
 */
export async function getAircrafts(query) {
	return API.get(`/aircraft`, query)
		.then(async (rs) => {
			if (rs && rs.status === 200 && rs.data) {
				const response = rs.data?.data ?? {};
				return { success: true, data: response };
			}
		})
		.catch((errRes) => {
			return {
				success: false,
				errors: errRes,
			};
		});
}
